// extracted by mini-css-extract-plugin
export var cardIcon = "_9y-5";
export var checkboxCard = "_9y-0";
export var checkboxCardSelected = "_9y-4";
export var disabled = "_9y-2";
export var interactive = "_9y-1";
export var outerBorder = "_9y-3";
export var spacerMedium = "_9y-8";
export var spacerSmall = "_9y-7";
export var spacerXsmall = "_9y-6";